import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { HttpApiService } from '@app/providers/http-api/http-api.service';

import {
  PledgeRead,
  Product,
} from '@app/forms/subscription/definition/interface/Pledge';
import {
  API_ROUTE_SEND_ELECTRONIC,
  API_ROUTE_SUBSCRIPTION_FILE,
} from '../../api/api-router';
import { InfoOption } from '../../components/info/info.component';
import { infoOption } from '../../services/ref';

import { MatDialog } from '@angular/material/dialog';
import { CommandEnum } from '@app/forms/subscription/definition/interface/enum';
import { throwError, catchError, finalize, map, take, tap } from 'rxjs';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { DocumentDialogComponent } from './document-dialog/document-dialog.component';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import { AttributionDao } from '@app/dao/attribution/attribution.dao';

export interface DocumentsSelect {
  check: string[];
  gedId: string;
  prGedId: number;
  index: number;
  name: string;
  signatures: any[];
  universignCheckBoxes?: string[];
}
@Component({
    selector: 'electronic-signature-form',
    templateUrl: './electronic-signature-form.component.html',
    styleUrls: ['./electronic-signature-form.component.scss'],
    standalone: false
})
export class ElectronicSignatureFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  optionInfo1: InfoOption = infoOption;
  docLoading: boolean = false;
  products: Product[] = [];
  isSubmitting: boolean = false;
  organizationId: number;
  cristalisOrganizationId: number = 251251251;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    private httpApiService: HttpApiService,
    private cdr: ChangeDetectorRef,
    public dialog: MatDialog,
    private attributionDao: AttributionDao,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.attributionDao.getOrganization().subscribe((data: any) => {
      this.organizationId = data.id;
    });
    this.subscriptionFacade.initForm(this, {
      isCristalisOrganization:
        this.organizationId === this.cristalisOrganizationId,
    });
    this.products = this.subscriptionFacade.getPledge().products;
  }
  download(product: Product) {
    this.docLoading = true;
    const pledge = this.subscriptionFacade.getPledge();
    const accountId = pledge?.accountId as string;
    const subscriptionFileId = product?.parameters.subscriptionFileId as string;
    if (subscriptionFileId) {
      this.httpApiService
        .getWithOptions(
          API_ROUTE_SUBSCRIPTION_FILE.replace(':accountId', accountId).replace(
            ':documentId',
            subscriptionFileId,
          ),
          { responseType: 'arraybuffer' },
        )
        .pipe(
          take(1),
          catchError(err => {
            this.docLoading = false;
            this.notificationService.error('Erreur lors du téléchargement');
            return throwError(err);
          }),
          finalize(() => {
            this.docLoading = false;
          }),
        )
        .subscribe(resp => {
          var blob = new Blob([resp], { type: 'application/pdf' });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `bulletin_de_souscription.pdf`;
          link.click();

          this.docLoading = false;

          this.cdr.detectChanges();
        });
    }
  }

  onSubmit() {
    this.form.markAsDirty();
    this.displayErrors();

    if (this.form.valid) {
      this.digitalLoan().subscribe(() => {
        this.isSubmitting = false;
      });
    }
  }
  digitalLoan() {
    this.isSubmitting = true;
    const pledge = this.subscriptionFacade.getPledge();
    const body = this.findPrint(pledge?.documents);

    return this.httpApiService
      .post(
        API_ROUTE_SEND_ELECTRONIC.replace(
          ':accountId',
          pledge?.accountId as string,
        ).replace(':id', pledge.id as any),
        body,
      )
      .pipe(
        take(1),
        catchError(err => {
          this.isSubmitting = false;
          this.notificationService.error(err.error.message);
          return err;
        }),
        map(data => {
          return data;
        }),
        tap((data: PledgeRead) => {
          data && this.setCommandAndGetUrl(data);
        }),
      );
  }
  findPrint(docs: DocumentsSelect[]) {
    return docs?.filter(doc => doc?.signatures?.length);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
  openDialog(): void {
    const dialogRef = this.dialog.open(DocumentDialogComponent, {
      width: '700px',
      data: { name: 'test', animal: 'test' },
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }
  setCommandAndGetUrl(data: PledgeRead) {
    const pledge = this.subscriptionFacade.getPledge();
    this.subscriptionFacade
      .putPledge({
        ...pledge,
        ...data,
        parameters: { ...data.parameters, ...this.form.value },
        commands: [CommandEnum.SAVE_OWNERS_DATA],
      })
      .pipe(
        catchError(err => {
          this.isSubmitting = false;
          return err;
        }),
        map((el: PledgeRead) => el.organizationESignature?.signatureUrl),
      )
      .subscribe(signatureUrl => {
        signatureUrl && this.subscriptionFacade.openPdfDialog({ signatureUrl });
        this.isSubmitting = false;
      });
  }
}
